import { useMemo } from 'react';

// Minimal stand-in: infers basic phase and host based on lobby shape
export function useRoomEngine(lobby, playerId, hostHints = []) {
  const hostId = useMemo(() => {
    const candidates = [lobby?.hostId, lobby?.host?.playerId, ...(Array.isArray(hostHints) ? hostHints : [])].filter(Boolean);
    return candidates.length ? String(candidates[0]) : null;
  }, [lobby?.hostId, lobby?.host?.playerId, hostHints]);

  const isHost = hostId && playerId && String(hostId) === String(playerId);
  const phase = lobby?.status || lobby?.phase || 'lobby';
  const summary = lobby?.game && typeof lobby.game === 'object' ? { key: lobby.game.key, name: lobby.game.name } : lobby?.game ? { key: lobby.game } : null;
  const round = lobby?.round || null;

  return { isHost, phase, summary, round };
}
